import { useTheme } from "@mui/material";
import { AccessibilityButtonStyle, LucidIconStyle } from "./LucidIcon.style";

type IProps = {
  id:string;
  disable?: boolean;
  icon:JSX.Element;
  onClick?:()=>void;
  size?: string;
  ariaLabel?:string;
}

export const LucidIcon = ({ id, disable, icon, size, ariaLabel, onClick }: IProps) => { 
  const theme = useTheme();
  return ( 
    <AccessibilityButtonStyle id={ id } aria-label={ ariaLabel }  onClick={ onClick }>
      <LucidIconStyle  disable={ disable } size={ size } theme={ theme } >
        { icon }
      </LucidIconStyle>
    </AccessibilityButtonStyle>
  );
};
